import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  skeletonPrimaryText: {
    maxHeight: 7,
    height: 7,
    margin: 0,
    marginBottom: 3,
    '&:last-child': {
      maxWidth: '70%'
    }
  }
})

export default useStyles
